import { AuthService } from '@/app/modules/auth/core/service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.auth.isLoggedIn().pipe(
      map((authenticated) => {
        if (!authenticated) {
          this.auth.logout().subscribe();
          this.router.navigate(['/login'], {
            queryParams: { returnUrl: state.url },
          });
        }

        return authenticated;
      })
    );
  }
}
